// import React, { useEffect, useState } from "react";
// import { returnFields } from "./returnFields";
// import { fetchCategorySubCategory } from "../../services/returnmd/returnmd.service";
// import { useSelector } from "react-redux";

// export default function CreateReturnMD({
//     initialValues,
//     onSubmit,
//     onCancel,
//     viewOnly,
//     isEdit
// }) {

//     const { userDetail } = useSelector((state) => state.login);

//     const [formData, setFormData] = useState({
//         itemCategory: "",
//         itemSubCategory: "",
//         returnReasonCodes: "",
//         returnWindowDays: "",
//         exchangeReasonCodes: "",
//         exchangeWindowDays: "",
//         createdBy: "",
//         createdDate: "",
//         updatedBy: "",
//         updatedDate: ""
//     });

//     const [categoryList, setCategoryList] = useState([]);
//     const [subCategoryList, setSubCategoryList] = useState([]);

//     /* ================= OPTIONS ================= */

//     const returnReasonOptions = [
//         "Damaged Product",
//         "Wrong Item",
//         "Size Issue",
//         "Quality Issue",
//         "Not as Described",
//         "Defective Item"
//     ];

//     const exchangeReasonOptions = [
//         "Size Issue",
//         "Color Issue",
//         "Different Product Needed",
//         "Upgrade Product"
//     ];

//     /* ================= FETCH CATEGORY ================= */

//     useEffect(() => {
//         loadCategories();
//     }, []);

//     const loadCategories = async () => {
//         try {
//             const data = await fetchCategorySubCategory();
//             setCategoryList(Array.isArray(data) ? data : []);
//         } catch (err) {
//             console.error("Category fetch error:", err);
//         }
//     };

//     /* ================= LOAD EDIT / VIEW ================= */

//     useEffect(() => {
//         if ((viewOnly || isEdit) && initialValues) {

//             const selected = categoryList.find(
//                 (i) => i.category === initialValues.itemCategory
//             );

//             setSubCategoryList(selected?.subCategories || []);

//             setFormData({
//                 itemCategory: initialValues.itemCategory || "",
//                 itemSubCategory: initialValues.itemSubCategory || "",
//                 returnReasonCodes: initialValues.returnReasonCodes?.join(", ") || "",
//                 returnWindowDays: initialValues.returnWindowDays || "",
//                 exchangeReasonCodes: initialValues.exchangeReasonCodes?.join(", ") || "",
//                 exchangeWindowDays: initialValues.exchangeWindowDays || "",
//                 createdBy: initialValues.createdBy || "",
//                 createdDate: initialValues.createdDate || "",
//                 updatedBy: initialValues.updatedBy || "",
//                 updatedDate: initialValues.updatedDate || ""
//             });
//         }
//     }, [initialValues, viewOnly, isEdit, categoryList]);

//     /* ================= CREATE MODE AUTO ================= */

//     useEffect(() => {
//         if (!viewOnly && !isEdit && userDetail) {
//             setFormData((prev) => ({
//                 ...prev,
//                 createdBy: `${userDetail.firstName || ""} ${userDetail.lastName || ""}`,
//                 createdDate: new Date().toISOString().split("T")[0]
//             }));
//         }
//     }, [userDetail, viewOnly, isEdit]);

//     /* ================= HANDLERS ================= */

//     const handleCategoryChange = (value) => {

//         const selected = categoryList.find(
//             (i) => i.category === value
//         );

//         setFormData((prev) => ({
//             ...prev,
//             itemCategory: value,
//             itemSubCategory: ""
//         }));

//         setSubCategoryList(selected?.subCategories || []);
//     };

//     const handleChange = (name, value) => {
//         setFormData((prev) => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     /* ================= SUBMIT ================= */

//     const submit = (e) => {
//         e.preventDefault();

//         const payload = {
//             itemCategory: formData.itemCategory,
//             itemSubCategory: formData.itemSubCategory,
//             returnWindowDays: Number(formData.returnWindowDays),
//             exchangeWindowDays: Number(formData.exchangeWindowDays),

//             returnReasonCodes:
//                 formData.returnReasonCodes
//                     ?.split(",")
//                     .map((i) => i.trim())
//                     .filter(Boolean),

//             exchangeReasonCodes:
//                 formData.exchangeReasonCodes
//                     ?.split(",")
//                     .map((i) => i.trim())
//                     .filter(Boolean),

//             createdBy: formData.createdBy,
//             createdDate: formData.createdDate,

//             updatedBy: isEdit
//                 ? `${userDetail.firstName || ""} ${userDetail.lastName || ""}`
//                 : "",

//             updatedDate: isEdit
//                 ? new Date().toISOString().split("T")[0]
//                 : ""
//         };

//         onSubmit(payload, initialValues?._id);
//     };

//     /* ================= UI ================= */

//     return (

//         <form onSubmit={submit}>

//             <div className="d-flex flex-wrap gap-3">

//                 {returnFields.map((field) => (

//                     <div key={field.name} style={{ flex: "0 0 23%" }}>

//                         <label className="form-label">
//                             {field.label}
//                             {field.required && <span className="text-danger"> *</span>}
//                         </label>

//                         {/* CATEGORY */}
//                         {field.name === "itemCategory" ? (

//                             <select
//                                 className="form-select"
//                                 value={formData.itemCategory}
//                                 disabled={viewOnly}
//                                 onChange={(e) => handleCategoryChange(e.target.value)}
//                             >
//                                 <option value="">Select Category</option>

//                                 {categoryList.map((cat) => (
//                                     <option key={cat.category} value={cat.category}>
//                                         {cat.category}
//                                     </option>
//                                 ))}
//                             </select>

//                         ) : field.name === "itemSubCategory" ? (

//                             <select
//                                 className="form-select"
//                                 value={formData.itemSubCategory}
//                                 disabled={!formData.itemCategory || viewOnly}
//                                 onChange={(e) => handleChange("itemSubCategory", e.target.value)}
//                             >
//                                 <option value="">Select SubCategory</option>

//                                 {subCategoryList.map((sub) => (
//                                     <option key={sub} value={sub}>
//                                         {sub}
//                                     </option>
//                                 ))}
//                             </select>

//                         ) : field.name === "returnReasonCodes" ? (

//                             <div>
//                                 <input
//                                     type="text"
//                                     list="returnReasons"
//                                     className="form-control"
//                                     value={formData.returnReasonCodes}
//                                     readOnly={viewOnly}
//                                     onChange={(e) => handleChange(field.name, e.target.value)}
//                                 />

//                                 <datalist id="returnReasons">
//                                     {returnReasonOptions.map((reason) => (
//                                         <option key={reason} value={reason} />
//                                     ))}
//                                 </datalist>
//                             </div>

//                         ) : field.name === "exchangeReasonCodes" ? (

//                             <div>
//                                 <input
//                                     type="text"
//                                     list="exchangeReasons"
//                                     className="form-control"
//                                     value={formData.exchangeReasonCodes}
//                                     readOnly={viewOnly}
//                                     onChange={(e) => handleChange(field.name, e.target.value)}
//                                 />

//                                 <datalist id="exchangeReasons">
//                                     {exchangeReasonOptions.map((reason) => (
//                                         <option key={reason} value={reason} />
//                                     ))}
//                                 </datalist>
//                             </div>

//                         ) : (

//                             <input
//                                 type={field.type || "text"}
//                                 className="form-control"
//                                 value={formData[field.name] || ""}
//                                 readOnly={viewOnly || field.readonly}
//                                 onChange={(e) => handleChange(field.name, e.target.value)}
//                             />

//                         )}

//                     </div>

//                 ))}

//             </div>

//             <div className="d-flex justify-content-center gap-2 mt-3">

//                 <button
//                     type="button"
//                     className="btn btn-secondary"
//                     onClick={onCancel}
//                 >
//                     Back
//                 </button>

//                 {!viewOnly && (
//                     <button
//                         type="submit"
//                         className="btn btn-primary"
//                     >
//                         {isEdit ? "Update" : "Save"}
//                     </button>
//                 )}

//             </div>

//         </form>
//     );
// }








import React, { useEffect, useState } from "react";
import { returnFields } from "./returnFields";
import { fetchCategorySubCategory } from "../../services/returnmd/returnmd.service";
import { useSelector } from "react-redux";

export default function CreateReturnMD({
    initialValues,
    onSubmit,
    onCancel,
    viewOnly,
    isEdit
}) {

    const { userDetail } = useSelector((state) => state.login);

    const [formData, setFormData] = useState({
        itemCategory: "",
        itemSubCategory: "",
        returnReasonCodes: "",
        returnWindowDays: "",
        exchangeReasonCodes: "",
        exchangeWindowDays: "",
        createdBy: "",
        createdDate: "",
        updatedBy: "",
        updatedDate: ""
    });

    const [errors, setErrors] = useState({});
    const [categoryList, setCategoryList] = useState([]);
    const [subCategoryList, setSubCategoryList] = useState([]);

    /* ================= OPTIONS ================= */

    const returnReasonOptions = [
        "Damaged Product",
        "Wrong Item",
        "Size Issue",
        "Quality Issue",
        "Not as Described",
        "Defective Item"
    ];

    const exchangeReasonOptions = [
        "Size Issue",
        "Color Issue",
        "Different Product Needed",
        "Upgrade Product"
    ];

    /* ================= FETCH CATEGORY ================= */

    useEffect(() => {
        loadCategories();
    }, []);

    const loadCategories = async () => {
        try {
            const data = await fetchCategorySubCategory();
            setCategoryList(Array.isArray(data) ? data : []);
        } catch (err) {
            console.error("Category fetch error:", err);
        }
    };

    /* ================= LOAD EDIT / VIEW ================= */

    useEffect(() => {
        if ((viewOnly || isEdit) && initialValues && categoryList.length) {

            const selected = categoryList.find(
                (i) => i.category === initialValues.itemCategory
            );

            setSubCategoryList(selected?.subCategories || []);

            setFormData({
                itemCategory: initialValues.itemCategory || "",
                itemSubCategory: initialValues.itemSubCategory || "",
                returnReasonCodes: initialValues.returnReasonCodes?.join(", ") || "",
                returnWindowDays: initialValues.returnWindowDays || "",
                exchangeReasonCodes: initialValues.exchangeReasonCodes?.join(", ") || "",
                exchangeWindowDays: initialValues.exchangeWindowDays || "",
                createdBy: initialValues.createdBy || "",
                createdDate: initialValues.createdDate || "",
                updatedBy: initialValues.updatedBy || "",
                updatedDate: initialValues.updatedDate || ""
            });
        }
    }, [initialValues, viewOnly, isEdit, categoryList]);

    /* ================= CREATE MODE AUTO ================= */

    useEffect(() => {
        if (!viewOnly && !isEdit && userDetail) {
            setFormData((prev) => ({
                ...prev,
                createdBy: `${userDetail.firstName || ""} ${userDetail.lastName || ""}`,
                createdDate: new Date().toISOString().split("T")[0]
            }));
        }
    }, [userDetail, viewOnly, isEdit]);

    /* ================= HANDLERS ================= */

    const handleCategoryChange = (value) => {

        const selected = categoryList.find(
            (i) => i.category === value
        );

        setFormData((prev) => ({
            ...prev,
            itemCategory: value,
            itemSubCategory: ""
        }));

        setSubCategoryList(selected?.subCategories || []);

        setErrors((prev) => ({
            ...prev,
            itemCategory: "",
            itemSubCategory: ""
        }));
    };

    const handleChange = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: ""
        }));
    };

    /* ================= VALIDATION ================= */

    const validate = () => {

        let newErrors = {};

        if (!formData.itemCategory) {
            newErrors.itemCategory = "Category is required";
        }

        if (!formData.itemSubCategory) {
            newErrors.itemSubCategory = "Sub Category is required";
        }

        if (!formData.returnReasonCodes) {
            newErrors.returnReasonCodes = "Return reason required";
        }

        if (!formData.returnWindowDays) {
            newErrors.returnWindowDays = "Return window days required";
        }

        if (!formData.exchangeReasonCodes) {
            newErrors.exchangeReasonCodes = "Exchange reason required";
        }

        if (!formData.exchangeWindowDays) {
            newErrors.exchangeWindowDays = "Exchange window days required";
        }

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    /* ================= SUBMIT ================= */

    const submit = (e) => {

        e.preventDefault();

        if (!validate()) return;

        const payload = {
            itemCategory: formData.itemCategory,
            itemSubCategory: formData.itemSubCategory,
            returnWindowDays: Number(formData.returnWindowDays),
            exchangeWindowDays: Number(formData.exchangeWindowDays),

            returnReasonCodes:
                formData.returnReasonCodes
                    ?.split(",")
                    .map((i) => i.trim())
                    .filter(Boolean),

            exchangeReasonCodes:
                formData.exchangeReasonCodes
                    ?.split(",")
                    .map((i) => i.trim())
                    .filter(Boolean),

            createdBy: formData.createdBy,
            createdDate: formData.createdDate,

            updatedBy: isEdit
                ? `${userDetail.firstName || ""} ${userDetail.lastName || ""}`
                : "",

            updatedDate: isEdit
                ? new Date().toISOString().split("T")[0]
                : ""
        };

        onSubmit(payload, initialValues?._id);
    };

    /* ================= UI ================= */

    return (

        <form onSubmit={submit}>

            <div className="d-flex flex-wrap gap-3">

                {returnFields.map((field) => (

                    <div key={field.name} style={{ flex: "0 0 23%" }}>

                        <label className="form-label">
                            {field.label}
                            {field.required && <span className="text-danger"> *</span>}
                        </label>

                        {/* CATEGORY */}
                        {field.name === "itemCategory" ? (

                            <select
                                className="form-select"
                                value={formData.itemCategory}
                                disabled={viewOnly}
                                onChange={(e) => handleCategoryChange(e.target.value)}
                            >
                                <option value="">Select Category</option>

                                {categoryList.map((cat) => (
                                    <option key={cat.category} value={cat.category}>
                                        {cat.category}
                                    </option>
                                ))}
                            </select>

                        ) : field.name === "itemSubCategory" ? (

                            <select
                                className="form-select"
                                value={formData.itemSubCategory}
                                disabled={!formData.itemCategory || viewOnly}
                                onChange={(e) => handleChange("itemSubCategory", e.target.value)}
                            >
                                <option value="">Select SubCategory</option>

                                {subCategoryList.map((sub) => (
                                    <option key={sub} value={sub}>
                                        {sub}
                                    </option>
                                ))}
                            </select>

                        ) : field.name === "returnReasonCodes" ? (

                            <div>
                                <input
                                    type="text"
                                    list="returnReasons"
                                    className="form-control"
                                    value={formData.returnReasonCodes}
                                    readOnly={viewOnly}
                                    onChange={(e) => handleChange(field.name, e.target.value)}
                                />

                                <datalist id="returnReasons">
                                    {returnReasonOptions.map((reason) => (
                                        <option key={reason} value={reason} />
                                    ))}
                                </datalist>
                            </div>

                        ) : field.name === "exchangeReasonCodes" ? (

                            <div>
                                <input
                                    type="text"
                                    list="exchangeReasons"
                                    className="form-control"
                                    value={formData.exchangeReasonCodes}
                                    readOnly={viewOnly}
                                    onChange={(e) => handleChange(field.name, e.target.value)}
                                />

                                <datalist id="exchangeReasons">
                                    {exchangeReasonOptions.map((reason) => (
                                        <option key={reason} value={reason} />
                                    ))}
                                </datalist>
                            </div>

                        ) : (

                            <input
                                type={field.type || "text"}
                                className="form-control"
                                value={formData[field.name] || ""}
                                readOnly={viewOnly || field.readonly}
                                onChange={(e) => handleChange(field.name, e.target.value)}
                            />

                        )}

                        {/* 🔥 ERROR SHOW */}
                        {errors[field.name] && (
                            <small className="text-danger">
                                {errors[field.name]}
                            </small>
                        )}

                    </div>

                ))}

            </div>

            <div className="d-flex justify-content-center gap-2 mt-3">

                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onCancel}
                >
                    Back
                </button>

                {!viewOnly && (
                    <button
                        type="submit"
                        className="btn btn-primary"
                    >
                        {isEdit ? "Update" : "Save"}
                    </button>
                )}

            </div>

        </form>
    );
}